import http from 'axios'
import { authApiURL as API_URL } from '../../utils'

const getSearchParams = ({ dc = null, client = null } = {}) => {
  const params = {
    action: 'getOtherSearchParams',
    dc: dc || null,
    client: client || null
  }
  return http.get(API_URL, { params }).then((res) => res.data)
}

const getSearchResults = ({ dc = null, client = null } = {}) => {
  const params = {
    action: 'getOtherSearchResults',
    dc: dc || null,
    client: client || null
  }
  return http.get(API_URL, { params }).then((res) => res.data)
}

const getDestinationPoints = ({
    dc = null,
    date = null,
    currency = null,
    product_type = null,
    product_tag = null
  } = {}) => {
  var params = {
    action: 'getOtherDestinationPoints',
    dc: dc || null,
    currency,
    date,
    product_type,
    product_tag
  }

  return http.get(API_URL, { params }).then((res) => res.data)
}

const getAllocDates = ({
    dc = null,
    currency = null,
    product_type = null,
    product_tags = null,
    destination = null
} = {}) => {
  var params = {
    action: 'getOtherAllocDates',
    dc: dc || null,
    currency,
    product_type,
    product_tags,
    destination
  }

  return http.get(API_URL, { params }).then((res) => res.data)
}

const getProductTags = ({
    dc = null,
    currency = null,
    date = null,
    product_type = null
  } = {}) => {
  var params = {
    action: 'getOtherProductTags',
    dc: dc || null,
    currency,
    date,
    product_type
  }

  return http.get(API_URL, { params }).then((res) => res.data)
}

const search = (params) => {
  return http.post(API_URL, params, { params: { action: 'runOtherSearch' } }).then(res => res.data)
}

const book = (params) => {
  return http.post(API_URL, params, { params: { action: 'bookOther' } }).then((res) => res.data)
}

export {
  getSearchParams,
  getSearchResults,
  getDestinationPoints,
  getProductTags,
  getAllocDates,
  search,
  book
}
